import CityServicePage from "@/pages/city-service/CityServicePage";
import { torontoResidential } from "@/mocks/cityServiceData";
export default function Page() { return <CityServicePage config={torontoResidential} />; }
